import React from 'react';

export const GameModesBtn = ({ backToModeChoice }) => {
  return (<div id="back-to-game-mode" onClick={backToModeChoice}>
    Game Modes &gt;
  </div>);
};
